import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/recent-market-information')({
  component: RecentMarketInformationLayout
});

function RecentMarketInformationLayout() {
  return <Outlet />;
}
